import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { BaseImage } from "scmp-app/components/common/base-image";

import PlayButton from "./play-button.svg";

type Props = {
  $isHeroVideo: boolean;
};

export const PreviewImage = styled(BaseImage)`
  position: relative;

  margin: 0;

  overflow: hidden;
`;

export const PreviewContainer = styled.div`
  position: relative;

  inline-size: 100%;
  block-size: 100%;

  cursor: pointer;

  ${props => props.theme.breakpoints.up("tablet")} {
    block-size: auto;
  }
`;

export const PreviewContentContainer = styled.div`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;

  display: flex;
  flex-flow: row;
  justify-content: flex-start;
  align-items: flex-end;

  inline-size: 100%;
  block-size: 100%;
  padding-block: 0 20px;
  padding-inline: 16px;

  column-gap: 12px;

  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6));

  ${props => props.theme.breakpoints.up("tablet")} {
    block-size: 100%;
    padding-block: 0 32px;
    padding-inline: 32px;
  }
`;

export const StyledPlayButton = styled(PlayButton)``;

export const PreviewPlayButtonContainer = styled.div<Props>`
  margin-inline-end: 12px;

  ${StyledPlayButton} {
    ${props =>
      props.$isHeroVideo
        ? css`
            inline-size: 40px;
            block-size: 40px;
            ${props.theme.breakpoints.up("tablet")} {
              inline-size: 60px;
              block-size: 60px;
            }
          `
        : css`
            inline-size: 28px;
            block-size: 28px;
            ${props.theme.breakpoints.up("tablet")} {
              inline-size: 32px;
              block-size: 32px;
            }
          `}
  }

  ${props => props.theme.breakpoints.up("tablet")} {
    ${props =>
      props.$isHeroVideo
        ? css`
            display: flex;
            align-items: center;

            margin-block-start: 0;
            margin-inline-end: 20px;
          `
        : css`
            display: flex;
            align-items: flex-start;

            margin-block-start: 0;
            margin-inline-end: 12px;
          `}
  }
`;

export const PreviewContentFloatContainer = styled.div`
  display: flex;

  x ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 508px;
  }
`;

export const PreviewTitle = styled.p<Props>`
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 16px;

  ${props => props.theme.breakpoints.up("tablet")} {
    ${props =>
      props.$isHeroVideo
        ? css`
            font-size: 24px;
            line-height: 34px;
          `
        : css`
            font-size: 14px;
            line-height: 16px;
          `}
  }
`;

export const PreviewDuration = styled.p<Props>`
  inline-size: fit-content;
  padding: 2px;

  color: #4585ff;
  font-weight: 700;
  font-size: 10px;
  font-family: ${fontRoboto};
  line-height: 12px;

  background-color: #ffffff;

  ${props => props.theme.breakpoints.up("tablet")} {
    margin-block-end: 2px;

    ${props =>
      props.$isHeroVideo &&
      css`
        font-size: 18px;
        line-height: 21px;
      `}
  }
`;

export const PreviewContentDataContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 4px;

  /* Override the style in content schema render */
  ${PreviewTitle}, ${PreviewDuration} {
    margin-block: 0;
  }
`;
